import { render, staticRenderFns } from "./salaryListShow.vue?vue&type=template&id=95269112&scoped=true&"
import script from "./salaryListShow.vue?vue&type=script&lang=js&"
export * from "./salaryListShow.vue?vue&type=script&lang=js&"
import style0 from "./salaryListShow.vue?vue&type=style&index=0&id=95269112&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95269112",
  null
  
)

export default component.exports